/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteFilesDto } from '../../models/delete-files-dto';

export interface StorageControllerDeleteManyV1$Params {
      body: DeleteFilesDto
}

export function storageControllerDeleteManyV1(http: HttpClient, rootUrl: string, params: StorageControllerDeleteManyV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'count'?: number;
}>> {
  const rb = new RequestBuilder(rootUrl, storageControllerDeleteManyV1.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'count'?: number;
      }>;
    })
  );
}

storageControllerDeleteManyV1.PATH = '/api/v1/storage';
